// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons___APk4","alertIcon":"ConfirmModal_alertIcon__3fomN"};